import gql from 'graphql-tag';
import {
  Component, Mixins,
} from 'vue-property-decorator';
import PimcoreIntrospectionCoreMixin from '@/mixins/PimcoreIntrospectionCoreMixin';
import NormalizerMixin from '@/mixins/NormalizerMixin';
import GraphQLFieldsExtractor from '@/classes/graphql-introspection/GraphQLFieldsExtractor';
import SystemFieldsExcluder from '@/classes/graphql-introspection/PimcoreSystemFieldsExcluder';
import EntitySchemaConstructor from '@/classes/schema-constructors/EntitySchemaConstructor';
import AsyncMemoizator from '@/classes/async-memoization/AsyncMemoizator';
import { FetchPolicy } from 'apollo-client/core/watchQueryOptions';
import { TypeExtractionRules } from '@/classes/schema-constructors/types';
import StorageMixin from '@/mixins/StorageMixin';

@Component
export default class EntityHelperMixin extends Mixins(PimcoreIntrospectionCoreMixin, NormalizerMixin, StorageMixin) {
  memoization: AsyncMemoizator = new AsyncMemoizator();

  async _loadEntityListing(entity: string, variables?: Record<string, string | number | undefined>, fetchPolicy: FetchPolicy = 'network-only', rules?: TypeExtractionRules) {
    const fieldsExcluder = new SystemFieldsExcluder();
    const fieldsExtractor = new GraphQLFieldsExtractor(fieldsExcluder);
    const coordinatorIntrospection = await this.getPimcoreIntrospection(entity);
    const coordinatorSchemaConstructor = new EntitySchemaConstructor(coordinatorIntrospection!, fieldsExtractor);
    const listingSchema = coordinatorSchemaConstructor.constructListingSchema(rules);

    const resp = await this.$apollo.query({
      query: gql`${listingSchema}`,
      variables,
      fetchPolicy,
    });
    const items = resp.data?.[`get${entity}Listing`]?.items?.map(
      ({ node }: any) => node
    );
    return {
      items,
      total: resp.data?.[`get${entity}Listing`]?.total || 0,
    };
  }

  async loadEntityListing(entity: string, variables?: Record<string, string | number | undefined>, fetchPolicy: FetchPolicy = 'network-only', rules?: TypeExtractionRules) {
    const data = await this._loadEntityListing(entity, variables, fetchPolicy, rules);
    return data.items;
  }
}
